// extracted by mini-css-extract-plugin
export default {"main":"LastSynced_main__85Ntx","when":"LastSynced_when__9IrzC"};